import { CarryOutOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import TaskBaseCreateMenu from 'automations/components/Nodes/TaskBaseCreateMenu';
import { nodeSchemas, type TaskCreateNodeType } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type TriggerNodeReturnProps } from './useTriggerNodeConfig';

export default function useTaskCreate(node: NodeProps<TaskCreateNodeType>): TriggerNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.TaskCreateNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <TaskBaseCreateMenu node={node} />, [node]);

  return {
    icon: CarryOutOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
